// import { HasPermission } from '../../Helper/Permisstions/Permisstions';

const arMenu = [
  {
    System: 'AR',
    isActive: false,
    menu: [
      { is_header: true, title: 'receivablesManagement', isActive: true }, 
 
        {
        path: '/AR/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      { is_header: true, title: 'Settings', isActive: true },

       
      {
        path: '/AR/Customers',
        icon: 'fas fa-user-tie',
        title: 'Customers',
        isActive: true,
      },
      {
        path: '/AR/PaymentTerms',
        icon: 'fas fa-calendar-check',
        title: 'PaymentTerms',
        isActive: true,
      },
      {
        path: '/AR/Currencies',
        icon: 'fas fa-coins',
        title: 'Currencies',
        isActive: true,
      },

      { is_header: true, title: 'Operations', isActive: true },
      {
        path: '/AR/ArTransactions',
        icon: 'fas fa-money-check-alt',  
        title: 'ReceivablesInvoices',
        isActive: true,
      },

      {
        path: '/AR/CreateAccountArTransactions',
        icon: 'fas fa-share-square',  
        title: 'PostReceivablesInvoices',
        isActive: true,
      },

      {
        path: '/AR/ArReceipts',
        icon: 'fas fa-cash-register',  
        title: 'Receipts',
        isActive: true,
      },
      {
        path: '/AR/CreateAccountArReceipts',
        icon: 'fas fa-share-square',  
        title: 'PostReceipts',
        isActive: true,
      },
      {
        path: '/AR/AccountingPeriod',
        title: 'AccountingPeriod',
        icon: 'fas fa-calendar-alt',
        isActive: true,
      },

      { is_header: true, title: 'Reports', isActive: true },
      {
        path: '/AR/ArReports',
        icon: 'fas fa-chart-line',
        title: 'Reports',
         isActive: true 
      },
      {
        path: '/AR/ArDashboards',
        icon: 'fas fa-th-large',
        title: 'Dashboard',
         isActive: true 
      },

       
    ],
  },
];

export default arMenu;
